// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterDropdownTextItem_root__2N0IV","active":"FilterDropdownTextItem_active__2XR6J","disabled":"FilterDropdownTextItem_disabled__2hp7t"};